import { useContext } from 'react';
import { storeContext } from '@/store';

export default () => useContext(storeContext);
